import { createStyles } from '@mantine/core';

interface TreeNodeStyleProps {
	open?: boolean;
	selected?: boolean;
}

export const useTreeNodeStyle = createStyles(
	(theme, { open, selected }: TreeNodeStyleProps) => ({
		button: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			height: theme.other.space[7],
			borderRadius: theme.other.borderRadius.sm,
			paddingTop: theme.other.space[0.25],
			color: theme.other.getColor('text/primary/default'),
			cursor: 'pointer',
			backgroundColor: selected
				? theme.other.getColor('fill/transparent/selected')
				: 'transparent',
			':hover': {
				backgroundColor: theme.other.getColor('fill/transparent/hover'),
			},
			':active': {
				backgroundColor: theme.other.getColor('fill/transparent/active'),
			},
		},
		contentContainer: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			width: '100%',
		},
		leftSection: {
			display: 'flex',
			alignItems: 'center',
			flex: '0 0 auto',
		},
		rightSection: {
			display: 'flex',
			alignItems: 'center',
			flex: 1,
			minWidth: 0,
		},
		iconContainer: {
			marginLeft: theme.other.space[1],
			marginRight: theme.other.space[1],
			width: theme.other.space[5],
			display: 'flex',
			justifyContent: 'center',
			flexShrink: 0,
		},
		loadMoreButton: {
			cursor: 'pointer',
			display: 'flex',
			width: '100%',
			height: theme.other.space[7],
			borderRadius: theme.radius.sm,
			fontWeight: theme.other.typography.weight.semibold,
			color: theme.other.getColor('text/primary/default'),
			':hover': {
				backgroundColor: theme.other.getColor('fill/transparent/hover'),
			},
			':active': {
				backgroundColor: theme.other.getColor('fill/transparent/active'),
			},
		},
		toggleContainer: {
			display: 'flex',
			alignItems: 'center',
			width: theme.other.space[7],
		},
		chevron: {
			transform: open ? 'rotate(90deg)' : 'none',
			transition: 'transform 100ms ease',
		},
		chevronButton: {
			padding: 0,
			width: theme.other.space[7],
			height: theme.other.space[7],
			marginRight: theme.other.space[1],
		},
		textContainer: {
			flex: 1,
			minWidth: 0,
			position: 'relative',
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			borderRadius: theme.other.borderRadius.sm,
		},
		textContent: {
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: '100%',
		},
	})
);
